<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/中小微企.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">对中小微企业的扶植性贷款(普惠金融)</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>如何向缺乏信用历史的中小微企业提供扶植性的贷款是一个风控难题，一个重要的解决方案是使用政府大数据为授信和贷后管理提供数字化辅助决策手段。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              如何使用大数据局汇聚的数据为普惠金融政策的实施提供操作手段？
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" >
          <p style="text-indent: 0;">将部盾的分析平台和某省大数据局提供的数据对接，最终生成授信和贷后风险报告：</p>
          <p>对大数据局汇聚的各类数据进行了完整的扫描，并建立了数据处理规范，做为建立标尺体系的数据基础</p>
          <p>基于上述数据，建立了对企业运行状态进行评估的指标体系，并建立的评分模型</p>
          <p>使用上述数据、评分模型和指标体系，建立了授信和贷后风险报告</p>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/组4.png" style="width: 1200px;height;588px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "jinrong",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>